<template>
  <div :class="$style['tapes']" aria-hidden="true">
    <div v-for="tape in tapes" :key="tape.name" :class="[$style['tape'], $style[`tape--${tape.name}`]]">
      <div :class="$style['tape__track']">
        <template v-for="copy in 2" :key="copy">
          <template v-for="line in tape.lines" :key="`${copy}-${line}`">
            <span>{{ line }}</span>
            <SiteMark />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
// Two crossed marquee tapes, the amber one on top
const props = defineProps<{ amber: Array<string>, red: Array<string> }>()

const tapes = computed(() => [
  { name: 'red', lines: props.red.filter(Boolean) },
  { name: 'amber', lines: props.amber.filter(Boolean) }
])
</script>
<style module>
.tapes {
  position: relative;
  display: grid;
  place-items: center;
  height: clamp(15rem, 30vw, 28rem);
  overflow: hidden;
  background: var(--stage-black);
}

.tape {
  position: absolute;
  left: -10%;
  width: 120%;
  padding-block: clamp(0.9rem, 0.6rem + 0.8vw, 1.5rem);
  overflow: hidden;
  box-shadow: 0 1.5rem 3rem oklch(0% 0 0deg / 50%);
}

.tape--amber {
  z-index: 2;
  background: var(--primary-color);
  color: var(--stage-black);
  transform: rotate(-4deg);
}

.tape--red {
  background: var(--secondary-color);
  color: var(--stage-white);
  transform: rotate(3.5deg);
}

.tape__track {
  display: flex;
  align-items: center;
  gap: 0.6em;
  width: max-content;
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-bold);
  font-size: clamp(1.75rem, 1rem + 3vw, 4.25rem);
  line-height: 1;
  letter-spacing: -0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  animation: tape-run 38s linear infinite;
}

.tape--red .tape__track {
  animation-direction: reverse;
  animation-duration: 46s;
}

@keyframes tape-run {
  to { transform: translateX(-50%); }
}

@media (prefers-reduced-motion: reduce) {
  .tape__track {
    animation: none;
  }
}
</style>
